import {Stack} from 'shells/layout/stack/stack';
import {StatusBadge} from 'shells/status-badge/status-badge';
import {Body} from 'shells/typography/body';

import {VerificationState, STATUS_BADGE_PROPS} from './consts';

interface Props {
    title: string;
    verificationState: VerificationState;
    description: string;
    headerAction: React.ReactNode;
    children?: React.ReactNode;
}

export function SetupSection(props: Props) {
    const badgeProps = STATUS_BADGE_PROPS[props.verificationState];

    return (
        <div className='border br-8'>
            <div className='flex align-center justify-sb pad-16'>
                <Stack spacing={4}>
                    <Stack isHorizontal={true} spacing={8} alignItems='center'>
                        <Body isBold={true} size='large' color='dark'>
                            {props.title}
                        </Body>
                        <StatusBadge level={badgeProps.level} text={badgeProps.text} />
                    </Stack>
                    <Body color='medium' size='small'>
                        {props.description}
                    </Body>
                </Stack>
                {props.headerAction}
            </div>
            {props.children}
        </div>
    );
}
